module.exports = __webpack_public_path__ + "324225320862e5f2bb30c3115509aaab.png";


//////////////////
// WEBPACK FOOTER
// ./sideLogo.png
// module id = 744
// module chunks = 0